<template>
<section>
  <b-row class="mb-2">
    <b-col cols="4">
      <b-form-group label-cols="4" label-align="right" label="Currency">
        <b-form-select v-model="quote.currencyTypeId">
          <option v-for="(select, index) in sortSelect(currencies)" :key="index" :value="select.id">{{ select.name }}
          </option>
        </b-form-select>
      </b-form-group>
    </b-col>
    <b-col cols="3">
      <b-form-group label-cols="7" label-align="right" label="Exch. Rate">
        <b-input-group prepend="$" size="sm">
          <b-form-input v-model="quote.exchangeRate" />
        </b-input-group>
      </b-form-group>
    </b-col>
    <b-col cols="2">
      <b-form-group label-align="right">
        <b-form-checkbox v-model="quote.isTaxable"  >
          Taxable
        </b-form-checkbox>
      </b-form-group>
    </b-col>
    <b-col cols="3">
      <b-form-group label-cols="5" label-align="right" label="Tax Rate">
        <b-form-input v-model="quote.taxRate" @input="onChangeTaxRate"/>
      </b-form-group>
    </b-col>
  </b-row>
  <b-row>
    <label class="col-sm-4 col-form-label text-center">{{CustAndVendAmtTitle}}</label>
    <label class="col-sm-4 col-form-label text-center">Converted Amounts</label>
    <label class="col-sm-4 col-form-label text-center">{{CostAndMarginTitle}}</label>
    <!--<label class="col-sm-1 col-form-label"></label>-->
  </b-row>
  <b-row>
    <b-col cols="4">
      <b-form-group label-cols="4" label-align="right" label="Sub Total">
        <b-input-group :prepend="formattedProps.currencySymbol" size="sm">
          <b-form-input disabled v-model="formattedProps.subTotal" />
        </b-input-group>
      </b-form-group>
      <b-form-group label-cols="4" label-align="right" label="Charges">
        <b-input-group :prepend="formattedProps.currencySymbol" size="sm">
          <b-form-input disabled v-model="formattedProps.totalCharges" />
        </b-input-group>
      </b-form-group>
      <b-form-group label-cols="4" label-align="right" label="Tax">
        <b-input-group :prepend="formattedProps.currencySymbol" size="sm">
          <b-form-input disabled type="number" v-model="formattedProps.tax" />
        </b-input-group>
      </b-form-group>
       <b-form-group label-cols="4" label-align="right" label="Expenses">
        <b-input-group prepend="$" size="sm">
          <b-form-input disabled :value="formattedProps.totalChargesCostConverted" />
        </b-input-group>
      </b-form-group>
      <b-form-group label-cols="4" label-align="right" label="Total">
        <b-input-group :prepend="formattedProps.currencySymbol" size="sm">
          <b-form-input disabled v-model="formattedProps.total" />
        </b-input-group>
      </b-form-group>
      <b-form-group label-cols="4" label-align="right" label="Paid">
        <b-input-group :prepend="'$'" size="sm">
          <b-form-input disabled v-model="formattedProps.amountPaid" />
        </b-input-group>
      </b-form-group>
      <b-form-group label-cols="4" label-align="right" label="Credit">
        <b-input-group :prepend="'$'" size="sm">
          <b-form-input disabled v-model="formattedProps.creditAmount" />
        </b-input-group>
      </b-form-group>
      <b-form-group label-cols="4" label-align="right" label="Balance">
        <b-input-group :prepend="'$'" size="sm">
          <b-form-input disabled v-model="formattedProps.balance" />
        </b-input-group>
      </b-form-group>
    </b-col>
    <b-col cols="4">
      <b-form-group label-cols="4" label-align="right" label="Sub Total">
        <b-input-group prepend="$" size="sm">
          <b-form-input disabled :value="formattedProps.subTotalConverted" @change="formatNumber"/>
        </b-input-group>
      </b-form-group>
      <b-form-group label-cols="4" label-align="right" label="Charges">
        <b-input-group prepend="$" size="sm">
          <b-form-input disabled v-model="formattedProps.totalChargesConverted" @change="formatNumber"/>
        </b-input-group>
      </b-form-group>
      <b-form-group label-cols="4" label-align="right" label="Tax">
        <b-input-group prepend="$" size="sm">
          <b-form-input disabled v-model="formattedProps.tax" @change="formatNumber"/>
        </b-input-group>
      </b-form-group>
           
      <b-form-group label-cols="4" label-align="right" label="Total">
        <b-input-group prepend="$" size="sm">
          <b-form-input disabled v-model="formattedProps.totalConverted" @change="formatNumber"/>
        </b-input-group>
      </b-form-group>
      <!-- <b-form-group label-cols="4" label-align="right">
        <b-input-group prepend="$" size="sm">
          <b-form-input disabled value="0.00" @change="formatNumber"/>
        </b-input-group>
      </b-form-group> -->
      <b-form-group label-cols="1" v-show="isPaymentView && quote.balance > 0 && formattedProps.credit > 0">
        <h6>Available Credits: {{ formattedProps.credit }}</h6>
        <apply-credits :details="quote" :page="page" ref="company-credits" @credit-result="companyCredits = $event" @credit-applied="$emit('credit-applied')" />
      </b-form-group>
    </b-col>
    <b-col cols="4">
      <!--<b-form-group label="Cost" class="mb-2">
        <b-input-group prepend="$" size="sm">
          <b-form-input disabled v-model="formattedProps.totalLineCost" @change="formatNumber"/>
        </b-input-group>
      </b-form-group>
      <b-form-group label="Margin" v-if="!isPurchaseOrderView">
        <b-input-group prepend="$" size="sm">
          <b-form-input disabled v-model="formattedProps.grossProfit" @change="formatNumber"/>
        </b-input-group>
        <b-input-group prepend="%" size="sm">
          <b-form-input disabled v-model="formattedProps.gpMargin" @change="formatNumber"/>
        </b-input-group>
      </b-form-group>-->
      <b-form-group label-cols="4" :label="isPurchaseOrderView ? 'PO Amount' : isWorkOrderView ? 'WO Amount' : 'Cost'" label-align="right">
        <b-input-group prepend="$" size="sm">
          <b-form-input disabled :value="formattedProps.totalLineCostConverted" v-if="isInvoiceView" />
          <b-form-input disabled :value="formattedProps.totalConverted" v-else />
        </b-input-group>
      </b-form-group>

      <b-form-group label-cols="4" label-align="right" label="Total Cost">
        <b-input-group prepend="$" size="sm">
          <b-form-input disabled :value="TCost"/>
        </b-input-group>
      </b-form-group>
      <!-- <b-form-group label-cols="4" label="Margin" label-align="right" v-if="isInvoiceView">
        <div class="input-group input-group-sm mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text">$</span>
          </div>
          <b-form-input disabled :value="formattedProps.grossProfit" @change="formatNumber"/>
          <div class="input-group-append">
            <span class="input-group-text">{{(formattedProps.gpMargin ? (formattedProps.gpMargin) : 0 )}} %</span>
          </div>
        </div>
      </b-form-group> -->
      <b-form-group label-cols="4" label-align="right" label="Profit" v-if="isInvoiceView">
        <b-input-group prepend="$" size="sm">
          <b-form-input disabled :value="formattedProps.grossProfit"/>
        </b-input-group>
      </b-form-group>
      <b-form-group label-cols="4" label-align="right" label="Margin" v-if="isInvoiceView">
        <b-input-group prepend="%" size="sm">
          <b-form-input disabled :value="formattedProps.gpMargin"/>
        </b-input-group>
      </b-form-group>

    </b-col>
    <!--<b-col>
      <b-alert variant="success" class="mt-1 text-center" show size="sm" v-if="isPaid"><strong>PAID</strong></b-alert>
    </b-col>-->
  </b-row>
</section>
</template>

<script>

import debounce from 'lodash/debounce';
import { mapActions, mapGetters } from 'vuex';
import ApplyCredits from '@/shared/components/ApplyCredits'

const DEBOUNCE_TIME = 750;

export default {
  props: {
    quote: {
      type: Object,
      default: () => {}
    },
    isPurchaseOrderView: {
      type: Boolean,
      default: false
    },
    isWorkOrderView: {
      type: Boolean,
      default: false
    },
    isInvoiceView: {
      type: Boolean,
      default: false
    },
    page: {
      type: String,
      default: "",
    },
    isPaid: {
      type: Boolean,
      default: false
    }
  },
  components:{
    ApplyCredits
  },
  data() {
    return {
      convertProps: [
        'subTotalConverted',
        'totalChargesConverted',
        'totalChargesTaxableConverted',
        'totalConverted'
      ],
      origProps: [
        'subTotal',
        'totalCharges',
        'totalChargesTaxable',
        'total'
      ],
      addtlProps: [
        'tax',
        'totalLineCostConverted',
        'totalChargesCostConverted',
        'grossProfit',
        'amountPaid',
        'creditAmount',
        'balance',
        'credit'
      ],
      formattedProps: {},
      companyCredits: []
    }
  },
  computed: {
    ...mapGetters('lookup', ['currencies']),
    isPaymentView() {
      return this.isInvoiceView || this.isPurchaseOrderView || this.isWorkOrderView;
    },
    TCost(){
      if((this.formattedProps.totalChargesCostConverted || this.formattedProps.totalLineCostConverted || this.formattedProps.totalConverted)) {
        let totalCost = (this.isInvoiceView) ? this.formattedProps.totalLineCostConverted : this.formattedProps.totalConverted;
        let totalChargesCostConverted = this.formattedProps.totalChargesCostConverted;

        if(typeof totalCost != 'number' && totalCost.indexOf(',') > -1){
          totalCost = Number(totalCost.replace(/,/g, ''));
        }else{
          totalCost = Number(totalCost);
        }

        if(typeof totalChargesCostConverted != 'number' && totalChargesCostConverted.indexOf(',') > -1){
          totalChargesCostConverted = Number(totalChargesCostConverted.replace(/,/g, ''));
        }else{
          totalChargesCostConverted = Number(totalChargesCostConverted);
        }

        let total_cost = totalCost + totalChargesCostConverted;
        return this.formatMoney(total_cost);
      }else {
        return null
      }
    },
    CustAndVendAmtTitle(){
      return `${this.isInvoiceView ? 'Customer Amount' : this.isPurchaseOrderView ? 'PO Amount' : this.isWorkOrderView ? 'WO Amount' : 'Amount'}`;
    },
    CostAndMarginTitle(){
      return `${this.isInvoiceView ? 'Cost and Margin' : this.isPurchaseOrderView ? 'PO Totals' : this.isWorkOrderView ? 'WO Totals' : ''}`;
    }
  },
  mounted() {
  },
  methods: {
    ...mapActions('quotes', ['updateTotals']),
    onChangeTaxRate() {
      this.quote.taxRate = this.quote.taxRate == '' || this.quote.taxRate == undefined || this.quote.taxRate == null ? 0 : this.quote.taxRate;
    },
    formatNumber(value, event) {
      return Number(value).toLocaleString();
    },
     onShippingChange: debounce (async function() {
      if (! this.quote.shippingCharge) {
         this.quote.shippingCharge = 0;
      }
      let body = { shipping: this.quote.shippingCharge, noChargeShipping: this.quote.noChargeShipping };
      var result = await this.getTotals(body);
      this.$emit('updateTotal',result);

    },DEBOUNCE_TIME),
    async getTotals(body) {
      const result = await this.updateTotals([this.quote.id, body]);
      return result;
    },
    formatMoney(val) {
      try {
        var str = Number(val || 0).toFixed(2).toString().split('.');
        if (str[0].length >= 3) {
          str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
        }
        if (str[1]) {
          if (str[1].length < 2) {
            while (str[1].length < 2) { str[1] = str[1] + "0"; }
          } else if (str[1].length > 2) {
            str[1] = str[1].substring(0, 2)
          }
        }
        return str.join('.');
      } catch {
        return val;
      }
    },
    initializeAndFormat() {
      if (this.isPaymentView && this.quote.balance > 0)
        this.$refs['company-credits'].resetModal(true);

      this.formattedProps = { ...this.quote };
      this.formattedProps.currencySymbol = this.formattedProps.currencySymbol ? this.formattedProps.currencySymbol : '$'
      var propsArr = this.origProps.concat(this.convertProps, this.addtlProps);

      propsArr.forEach(prop => {
        this.formattedProps[prop] = this.formatMoney(this.formattedProps[prop]);
      });
    },
  },
  watch: {
    'quote.exchangeRate'() {
      for (let i = 0; i < this.convertProps.length; i++) {
        let val = (typeof this.quote[this.origProps[i]] === 'string')
        ? parseFloat(this.quote[this.origProps[i]].replace(',',''))
        : this.quote[this.origProps[i]];

        this.quote[this.convertProps[i]] = (val * this.quote.exchangeRate);
        this.formattedProps[this.convertProps[i]] = this.formatMoney((val * this.quote.exchangeRate));
      }
    },
    quote() {
      this.initializeAndFormat();
    }
  }
};
</script>
